import Vue from 'vue';

export default {

    setIsCostablePageLoading(state, isLoading) {
        state.isCostablePageLoading = isLoading;
    },

    setIsCostableTableLoading(state, isLoading) {
        state.isCostableTableLoading = isLoading;
    },

    setCostable(state, { costable, type, id }) {
        state.costableType = type;
        state.costableId = id;
        state.costable = { ...costable };
    },

    setTabId(state, tabId) {
        state.tabId = tabId;
    },

    /**
     * Loops through all groups, selecting each cost.
     */
    selectAll(state, value) {
        state.costable.cost_groups.forEach((group) => {
            group.costs.filter(cost => cost.is_editable).forEach((cost) => {
                Vue.set(cost, 'selected', value);
            });
        });
    },

    /**
     * Finds group and sets each of its costs as selected.
     */
    selectGroup(state, { groupId, value }) {
        const group = state.costable.cost_groups.find(groupF => groupF.id === groupId);
        group.costs.forEach((cost) => {
            Vue.set(cost, 'selected', value);
        });
    },

    /**
     * Selects a cost.
     * We use the cost's `groupId` so we don't have to bother looping through all groups.
     */
    selectCost(state, { groupId, costId, value }) {
        const group = state.costable.cost_groups.find(costGroup => costGroup.id === groupId);
        const cost = group.costs.find(groupCost => groupCost.id === costId);
        Vue.set(cost, 'selected', value);
    },

    setFilters(state, value) {
        state.filters = { ...state.filters, ...value };
    },

    setGroups(state, groups) {
        Vue.set(state.costable, 'cost_groups', groups);
    },

    setGroupCosts(state, { groupId, costs }) {
        const group = state.costable.cost_groups.find(groupF => groupF.id === groupId);
        Vue.set(group, 'costs', costs);
    },

    setTabs(state, tabs) {
        Vue.set(state.costable, 'tabs', tabs);
    },

    incrementEditableUid(state) {
        state.nextEditableUid += 1;
    },

    SET_SETTINGS(state, value) {
        state.settings = value;
    },

    SET_SERVICE_CHARGE(state, value) {
        state.costable.service_charge = value;
    },

    SET_HIDDEN_COLUMNS(state, value) {
        state.hiddenColumns = value;
    },

    SET_PROGRESS(state, value) {
        state.progress = value;
    },

    SET_PROGRESS_INTERVAL(state, intervalId) {
        state.progressIntervalId = intervalId;
    },

};
